<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11">Bemerkung der Autorin</h1>
<p class="p6"><span class="t5"> </span></p>
<p class="p6"><span class="t6">V</span><span class="t7">IELES</span> <span class="t7">HAT</span> sich geändert, seit <span class="t4">Horizons</span> 2009 zum ersten Mal veröffentlicht wurde. Zwölf Staaten haben die gleichgeschlechtliche Ehe anerkannt, und erst vor kurzem hat sich eine bekannte Persönlichkeit in der Sportwelt zu ihrer Homosexualität bekannt. Nichtsdestotrotz gibt es noch viele Athleten, die aus einer Vielzahl von Gründen nicht in der Lage sind, zu ihrer sexuellen Orientierung zu stehen. Clarks und Jodys steiniger Weg zum Glück mag manchen extrem erscheinen, aber für viele in der gleichen Situation ist es traurige Realität. In fünf Jahren mag diese Geschichte nicht mehr relevant sein, aber heute ist sie es noch. Ich möchte diesen Roman all jenen widmen, die sich entscheiden müssen zwischen dem, was richtig ist und dem, was man von ihnen erwartet.</p>
<p class="p5"> </p>
<p class="p5">– Mickie B. Ashling, Juli 2013</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?702ba3be